import { useFormikContext } from 'formik';
import React from 'react';

import { Button, ButtonProps } from '../../Button/button.component';

export const SubmitButton: React.FC<ButtonProps & {
  disabledOnInvalid?: boolean;
}> = ({ disabledOnInvalid, ...props }) => {
  const formikContext = useFormikContext();

  const handleClick = React.useCallback(() => {
    formikContext.handleSubmit();
  }, [ formikContext ]);

  const disabled = React.useMemo(() => {
    if (disabledOnInvalid && !formikContext.isValid) {
      return true;
    }
    return props.disabled;
  }, [ disabledOnInvalid, formikContext.isValid, props.disabled ]);

  return (
    <Button
      onClick={handleClick}
      loading={formikContext.isSubmitting}
      disabled={disabled}
      variant="contained"
      color="primary"
      data-testid="submit-button"
      {...props}
    />
  );
};
